const cols = [
  ["Date", "invoiceDate"],
  ["Number", "invoiceNumber"],
  ["Due Date", "invoiceDueDate"],
  ["Total", "invoiceTotal"],
  ["Paid", "invoiceAmountPaid"],
  ["Paid Date", "invoiceFullyPaidDate"],
  ["Credited", "invoiceAmountCredited"],
  ["Due", "invoiceAmountDue"]
];

export const COLUMNS = cols.map(([Header, accessor]) => ({ Header, accessor }));

export const INVOICE_SUMMARY_COLUMNS = [
  { key: "invoiceTotal", colSpan: 1 },
  { key: "invoiceAmountPaid", colSpan: 2 },
  { key: "invoiceAmountCredited", colSpan: 1 },
  { key: "invoiceAmountDue", colSpan: 1 }
];
